<template>
    <div class="modal fade" tabindex="-1" aria-labelledby="tagModalLabel" aria-hidden="true" :id="id">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow">
                <!-- ヘッダー -->
                <div class="modal-header border-bottom-0 pb-2">
                    <h5 class="modal-title text-secondary">
                        <i :class="tag.id ? 'fa-solid fa-pen-to-square' : 'fa-solid fa-plus-circle'" class="me-2 text-primary"></i>
                        {{ tag.id ? 'タグ編集' : 'タグ作成' }}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <!-- ボディ -->
                <div class="modal-body px-4 py-3">
                    <!-- グローバルエラー -->
                    <div v-if="error.global" class="alert alert-danger d-flex align-items-start mb-3">
                        <i class="fa-solid fa-circle-exclamation me-2 mt-1"></i>
                        <span>{{ error.global }}</span>
                    </div>

                    <!-- タグ名称 -->
                    <div class="mb-3">
                        <label class="form-label text-muted small mb-2">
                            <i class="fa-solid fa-tag me-1"></i>タグ名称
                            <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                            <span class="input-group-text bg-light border-end-0">
                                <i class="fa-solid fa-tags text-muted"></i>
                            </span>
                            <input
                                type="text"
                                class="form-control border-start-0"
                                v-model="tag.name"
                                :class="{'is-invalid': error.name}"
                                placeholder="例: 重要案件"
                                required
                                data-error-key="name"
                            >
                        </div>
                        <div v-if="error.name" class="text-danger small mt-1">
                            <i class="fa-solid fa-circle-info me-1"></i>{{ error.name }}
                        </div>
                    </div>
                </div>

                <!-- フッター -->
                <div class="modal-footer border-top-0 pt-2 px-4">
                    <button type="button" class="btn btn-outline-secondary" @click="close">
                        <i class="fa-solid fa-xmark me-2"></i>キャンセル
                    </button>
                    <button type="button" class="btn btn-primary" @click="save">
                        <i class="fa-solid fa-floppy-disk me-2"></i>保存
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            default: 'tag-editor',
        },
        tag_id: {
            default: null,
        }
    },
    data() {
        return {
            tag: {},
            error: {},
        }
    },
    methods: {
        close() {
            this.$emit('close', this.id);
        },
        reload() {
            if (!this.tag_id) {
                this.tag = {};
                return;
            }
            axios.get(`/api/master/tag?id=${this.tag_id}`).then(res => {
                this.tag = res.data;
            }).catch(err => {
                Alert.err(err);
            });
        },
        validate() {
            this.error = {};
            if (!this.tag.name) this.error.name = 'タグ名称は必須です。';
            return Object.keys(this.error).length === 0;
        },
        save() {
            if (!this.validate()) { return; }
            axios.post('/api/master/tag', this.tag).then(() => {
                Alert.msg('保存しました。');
                this.$emit('saved');
                this.close();
            }).catch(e => {
                Alert.err(e.response);
            });
        }
    },
    mounted() {
        $(`#${this.id}`).on("show.bs.modal", (e) => {
            this.reload();
        });
    },
}
</script>
